import { Translator } from "Translator";
import { SubOption } from "model/Filters";

const priceSubOptions = [
  {
    id: 21,
    name: Translator.translate('UserEnvironment.Filters.minToMaxPricePerPerson', {
      minPrice: '€0',
      maxPrice: '€30',
    }, true, '{minPrice} - {maxPrice} per person'),
    value: 'cheap',
  },
  {
    id: 22,
    name: Translator.translate('UserEnvironment.Filters.minToMaxPricePerPerson', {
      minPrice: '€30',
      maxPrice: '€60',
    }, true, '{minPrice} - {maxPrice} per person'),
    value: 'medium-priced',
  },
  {
    id: 23,
    name: Translator.translate('UserEnvironment.Filters.moreThanSixtyPerPerson', { price: '€60+' }, true, '{price} per person'),
    value: 'luxury',
  },
] as SubOption[];


export default priceSubOptions;
